import * as React from 'react'
import { SVGProps } from 'react'

export const Playstore = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 60 60"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g clipPath="url(#clip0_10633_30960)">
			<path
				d="M10 0.5H50C55.2467 0.500002 59.5 4.7533 59.5 10V50C59.5 55.2467 55.2467 59.5 50 59.5H10C4.7533 59.5 0.5 55.2467 0.5 50V10C0.500001 4.7533 4.7533 0.5 10 0.5Z"
				fill="white"
				stroke="#D9DCE1"
			/>
			<g clipPath="url(#clip1_10633_30960)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M16.6373 12.5516C16.2326 12.9866 16 13.656 16 14.5259V45.4674C16 46.3373 16.2326 47.0067 16.6524 47.4265L16.7621 47.5192L34.0993 30.182V29.7924L16.747 12.459L16.6373 12.5516Z"
					fill="url(#paint0_linear_10633_30960)"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M39.8668 35.9839L34.084 30.1992V29.7945L39.8687 24.0098L39.9935 24.0873L46.8354 27.9753C48.7945 29.0797 48.7945 30.8989 46.8354 32.0184L39.9935 35.9064C39.9917 35.9064 39.8668 35.9839 39.8668 35.9839Z"
					fill="url(#paint1_linear_10633_30960)"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M39.9917 35.9066L34.084 29.9971L16.6372 47.4439C17.2745 48.1285 18.3467 48.206 19.5456 47.5366L39.9917 35.9066Z"
					fill="url(#paint2_linear_10633_30960)"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M39.9917 24.0892L19.5456 12.4743C18.3486 11.7898 17.2745 11.8824 16.6372 12.567L34.0821 29.9968L39.9917 24.0892Z"
					fill="url(#paint3_linear_10633_30960)"
				/>
				<path
					opacity="0.2"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M39.8669 35.7812L19.5608 47.3186C18.4262 47.971 17.4144 47.9256 16.762 47.3337L16.6523 47.4434L16.762 47.5361C17.4144 48.1261 18.4262 48.1734 19.5608 47.521L40.0069 35.9061L39.8669 35.7812Z"
					fill="black"
				/>
				<path
					opacity="0.12"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M46.8338 31.8163L39.8521 35.7818L39.9769 35.9066L46.8187 32.0186C47.7983 31.4588 48.2805 30.7289 48.2805 29.9971C48.2181 30.6665 47.7207 31.3038 46.8338 31.8163Z"
					fill="black"
				/>
				<path
					opacity="0.25"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M19.5457 12.6768L46.8336 28.1797C47.7205 28.677 48.2179 29.3295 48.2954 29.9989C48.2954 29.2689 47.8132 28.5371 46.8336 27.9774L19.5457 12.4745C17.5866 11.355 16 12.2873 16 14.5263V14.7286C16 12.4896 17.5866 11.5725 19.5457 12.6768Z"
					fill="white"
				/>
			</g>
		</g>
		<defs>
			<linearGradient
				id="paint0_linear_10633_30960"
				x1="32.5425"
				y1="14.1934"
				x2="4.77131"
				y2="21.5931"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#00A0FF" />
				<stop offset="0.00657" stopColor="#00A1FF" />
				<stop offset="0.2601" stopColor="#00BEFF" />
				<stop offset="0.5122" stopColor="#00D2FF" />
				<stop offset="0.7604" stopColor="#00DFFF" />
				<stop offset="1" stopColor="#00E3FF" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_10633_30960"
				x1="49.3848"
				y1="29.9977"
				x2="15.5236"
				y2="29.9977"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FFE000" />
				<stop offset="0.4087" stopColor="#FFBD00" />
				<stop offset="0.7754" stopColor="#FFA500" />
				<stop offset="1" stopColor="#FF9C00" />
			</linearGradient>
			<linearGradient
				id="paint2_linear_10633_30960"
				x1="36.7791"
				y1="33.2119"
				x2="14.4845"
				y2="70.7354"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FF3A44" />
				<stop offset="1" stopColor="#C31162" />
			</linearGradient>
			<linearGradient
				id="paint3_linear_10633_30960"
				x1="12.2453"
				y1="2.25931"
				x2="22.1918"
				y2="19.0179"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#32A071" />
				<stop offset="0.0685" stopColor="#2DA771" />
				<stop offset="0.4762" stopColor="#15CF74" />
				<stop offset="0.8009" stopColor="#06E775" />
				<stop offset="1" stopColor="#00F076" />
			</linearGradient>
			<clipPath id="clip0_10633_30960">
				<rect width="60" height="60" rx="10" fill="white" />
			</clipPath>
			<clipPath id="clip1_10633_30960">
				<rect
					width="32.303"
					height="36"
					fill="white"
					transform="translate(16 12)"
				/>
			</clipPath>
		</defs>
	</svg>
)
